<template>
  <v-text-field
    type="text"
    ref="autocomplete"
    v-model="value"
    v-bind="$attrs"
    @input="placeChanged"
  ></v-text-field>
</template>


<script>
export default {
  inheritAttrs: false,


  props: {
    googlePlace: {
      type: String
    },
    googlePlaceId: {
      type: String
    }
  },


  data () {
    return {
      autocomplete: null,
      googleScriptLoaded: false
    }
  },


  computed: {
    value: {
      get () {
        return this.googlePlace
      },
      set (val) {
        this.$emit('update:googlePlace', val)
        this.$emit('update:googlePlaceId', '')
      }
    }
  },


  methods: {
    placeChanged () {
      const place = this.autocomplete.getPlace()

      if (place) {
        this.$emit('update:googlePlace', place.name)
        this.$emit('update:googlePlaceId', place.place_id)
      }
    },

    initAutocomplete () {
      this.autocomplete = new window.google.maps.places.Autocomplete(this.$refs.autocomplete.$refs.input, { })
      // overriding google placeholder with our placeholder:
      this.$refs.autocomplete.$refs.input.setAttribute('placeholder', this.$attrs.placeholder || '')
      window.google.maps.event.addListener(this.autocomplete, 'place_changed', this.placeChanged)
    }
  },


  mounted () {
    if (document.getElementById('GoogleMapsScript') === null) {
      const googleScript = document.createElement('script')
      googleScript.setAttribute('id', 'GoogleMapsScript')
      googleScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?libraries=places&key=${process.env.VUE_APP_GOOGLE_API_KEY}`)
      googleScript.onload = () => {
        this.googleScriptLoaded = true
        this.initAutocomplete()
      }
      document.head.appendChild(googleScript)
    } else {
      this.googleScriptLoaded = true
    }

    if (this.googleScriptLoaded && !this.autocomplete) {
      this.initAutocomplete()
    }
  }
}
</script>
